export const languages = {
  'en-US': 'en',
  'ko-KR': 'kr',
};

export const languageItems = [
  { id: 1, name: 'English', flag: 'gb', code: 'en', lang: 'en-US' },
  { id: 2, name: '한국어', flag: 'kr', code: 'kr', lang: 'ko-KR' },
];
